import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMasterAuth } from "@/contexts/MasterAuthContext";
import { useEffect } from "react";
import { Crown, LayoutDashboard, Building2, CreditCard, Settings, LogOut, Plus, History, Megaphone, Inbox } from "lucide-react";

const NAV = [
    { to: "/master/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/master/clubs", label: "Kulüpler", icon: Building2 },
    { to: "/master/onboarding", label: "Yeni Kulüp", icon: Plus },
    { to: "/master/leads", label: "Demo Talepleri", icon: Inbox },
    { to: "/master/marketing", label: "Pazarlama", icon: Megaphone },
    { to: "/master/plans", label: "Paketler", icon: CreditCard },
    { to: "/master/audit-log", label: "Audit Log", icon: History },
    { to: "/master/system", label: "Sistem", icon: Settings },
];

export default function MasterLayout({ children }) {
    const { admin, loading, logout } = useMasterAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && !admin) navigate("/master/login");
    }, [loading, admin, navigate]);

    if (loading || !admin) {
        return <div data-testid="master-loading" className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center">Yükleniyor…</div>;
    }

    return (
        <div data-testid="master-layout" className="min-h-screen bg-[#0a0a0a] text-white flex" style={{ fontFamily: "'Manrope', sans-serif" }}>
            {/* Sidebar */}
            <aside className="w-64 bg-[#0f0f0f] border-r border-[#1f1f1f] flex flex-col">
                <div className="p-6 border-b border-[#1f1f1f]">
                    <div className="flex items-center gap-2 text-yellow-400 mb-1">
                        <Crown size={18} />
                        <span className="text-xs font-bold uppercase tracking-widest">Master Panel</span>
                    </div>
                    <h2 className="text-xl font-extrabold tracking-tight">DR AI FUTBOL</h2>
                </div>
                <nav className="flex-1 p-3 space-y-1">
                    {NAV.map(({ to, label, icon: Icon }) => {
                        const active = location.pathname.startsWith(to);
                        return (
                            <Link key={to} to={to} data-testid={`master-nav-${to.split("/").pop()}`} className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all text-sm font-medium ${active ? "bg-yellow-500/10 text-yellow-400 border border-yellow-500/30" : "text-neutral-300 hover:bg-[#1a1a1a] hover:text-white border border-transparent"}`}>
                                <Icon size={16} />
                                {label}
                            </Link>
                        );
                    })}
                </nav>
                <div className="p-4 border-t border-[#1f1f1f]">
                    <div className="text-xs text-neutral-500 mb-2 truncate">{admin.email}</div>
                    <button data-testid="master-logout-btn" onClick={logout} className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-[#1a1a1a] hover:bg-red-500/20 hover:text-red-400 text-neutral-400 text-sm rounded-lg transition-colors border border-[#2a2a2a]">
                        <LogOut size={14} /> Çıkış
                    </button>
                </div>
            </aside>
            {/* Main */}
            <main className="flex-1 overflow-auto">
                <div className="max-w-7xl mx-auto p-8">{children}</div>
            </main>
        </div>
    );
}
